export const mobile = 'screen and (max-width: 767px)'
export const se = 'screen and (max-width: 550px)'
export const tablet = 'screen and (max-width: 1023px)'
export const smallDesktop = 'screen and (max-width: 1260px)'
export const desktop = 'screen and (max-width: 1439px)'
